import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface Supplier {
  code: string;
  name: string;
}

/**
 * Stato UI per il SupplierPicker dentro la CommandBar.
 *
 * NB: questo slice è **predisposto** ma non ancora collegato al
 * `SearchRequest` BE — lo schema booking-engine non accetta
 * `supplier_codes` (verificare con backend). Quando il BE estenderà
 * `SearchRequest`, leggere `selected` dentro `searchHotelsApiV1SearchPost`
 * e includerlo nel payload.
 *
 * `available` è popolato dal SupplierPicker stesso al primo render
 * (placeholder hardcoded finché non c'è un endpoint /workspaces/suppliers).
 */
export interface SelectedSuppliersState {
  /** Supplier disponibili (dal workspace dell'agency). */
  available: Supplier[];
  /** Codici supplier selezionati per le prossime ricerche. Vuoto = tutti. */
  selected: string[];
}

const initialState: SelectedSuppliersState = {
  available: [],
  selected: [],
};

const selectedSuppliersSlice = createSlice({
  name: "selectedSuppliers",
  initialState,
  reducers: {
    setAvailableSuppliers(state, action: PayloadAction<Supplier[]>) {
      state.available = action.payload;
      const codes = new Set(action.payload.map((s) => s.code));
      state.selected = state.selected.filter((c) => codes.has(c));
    },
    toggleSupplier(state, action: PayloadAction<string>) {
      const code = action.payload;
      const idx = state.selected.indexOf(code);
      if (idx >= 0) state.selected.splice(idx, 1);
      else state.selected.push(code);
    },
    setSelectedSuppliers(state, action: PayloadAction<string[]>) {
      state.selected = action.payload;
    },
    clearSelectedSuppliers(state) {
      state.selected = [];
    },
  },
});

export const {
  setAvailableSuppliers,
  toggleSupplier,
  setSelectedSuppliers,
  clearSelectedSuppliers,
} = selectedSuppliersSlice.actions;
export default selectedSuppliersSlice.reducer;
